import React, { useMemo, useState } from 'react';
import http from '../../api/http';
import './mobile.css';

const riskOptions = [
  { value: '低', label: '低' },
  { value: '中', label: '中' },
  { value: '高', label: '高' },
];

export default function MobileHazardReportPage() {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [form, setForm] = useState({
    inspection_type: 'GENERAL',
    hazard_description: '',
    risk_level: '中',
    rectification_responsible: '',
    rectification_deadline: '',
    remark: '',
  });

  const [files, setFiles] = useState([]);

  const canSubmit = useMemo(() => {
    if (!form.inspection_type) return false;
    if (!String(form.hazard_description || '').trim()) return false;
    if (!String(form.risk_level || '').trim()) return false;
    if (!String(form.rectification_responsible || '').trim()) return false;
    if (!String(form.rectification_deadline || '').trim()) return false;
    return true;
  }, [form]);

  const onChange = (k) => (e) => {
    setForm((prev) => ({ ...prev, [k]: e.target.value }));
  };

  const onPickFiles = (e) => {
    const list = Array.from(e.target.files || []);
    setFiles(list);
  };

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!canSubmit) return;

    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const res = await http.post('/hazard/inspections', {
        inspection_type: form.inspection_type,
        hazard_description: String(form.hazard_description || '').trim(),
        risk_level: form.risk_level,
        rectification_responsible: String(form.rectification_responsible || '').trim(),
        rectification_deadline: form.rectification_deadline,
        remark: form.remark || '',
        status: 'PENDING',
      });

      const id = res?.data?.id;
      if (!id) throw new Error('创建隐患记录失败（未返回ID）');

      for (const f of files) {
        const fd = new FormData();
        fd.append('file', f);
        await http.post(`/hazard/inspections/${id}/attachments`, fd);
      }

      setSuccess(`已上报隐患（ID: ${id}）`);
      setForm({
        inspection_type: 'GENERAL',
        hazard_description: '',
        risk_level: '中',
        rectification_responsible: '',
        rectification_deadline: '',
        remark: '',
      });
      setFiles([]);
    } catch (err) {
      setError(err?.response?.data?.error || err?.response?.data?.message || err?.message || '上报失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="m-section">
      <div className="m-card m-cardPad">
        <div className="m-h2">隐患上报</div>
        <div className="m-muted">员工拍照上报隐患，填写表单描述后提交。</div>
        {error ? <div className="m-alert m-alertErr" style={{ marginTop: 10 }}>{error}</div> : null}
        {success ? <div className="m-alert" style={{ marginTop: 10 }}>{success}</div> : null}
      </div>

      <form className="m-card m-cardPad m-form" onSubmit={submit}>
        <div className="m-field">
          <div className="m-label">隐患描述 *</div>
          <textarea className="m-textarea" value={form.hazard_description} onChange={onChange('hazard_description')} placeholder="请描述隐患位置、现象、可能后果等" />
        </div>

        <div className="m-row">
          <div className="m-field">
            <div className="m-label">风险等级 *</div>
            <select className="m-select" value={form.risk_level} onChange={onChange('risk_level')}>
              {riskOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
          <div className="m-field">
            <div className="m-label">检查类型 *</div>
            <select className="m-select" value={form.inspection_type} onChange={onChange('inspection_type')}>
              <option value="GENERAL">GENERAL</option>
              <option value="DAILY">DAILY</option>
              <option value="SPECIAL">SPECIAL</option>
            </select>
          </div>
        </div>

        <div className="m-field">
          <div className="m-label">整改责任人 *</div>
          <input className="m-input" value={form.rectification_responsible} onChange={onChange('rectification_responsible')} placeholder="责任人姓名" />
        </div>

        <div className="m-field">
          <div className="m-label">整改期限 *</div>
          <input className="m-input" type="date" value={form.rectification_deadline} onChange={onChange('rectification_deadline')} />
        </div>

        <div className="m-field">
          <div className="m-label">现场照片（可选）</div>
          <input
            className="m-input"
            type="file"
            accept="image/*"
            capture="environment"
            multiple
            onChange={onPickFiles}
          />
          <div className="m-muted">已选择：{files.length} 张</div>
        </div>

        <div className="m-field">
          <div className="m-label">备注（可选）</div>
          <input className="m-input" value={form.remark} onChange={onChange('remark')} placeholder="补充说明" />
        </div>

        <button className="btn" type="submit" disabled={!canSubmit || saving}>
          {saving ? '提交中...' : '提交上报'}
        </button>
      </form>
    </div>
  );
}
